import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Title, Meta } from '@angular/platform-browser';
import { MenuComponent } from '../../layout/menu/menu.component';
import { RodapeComponent } from '../../layout/rodape/rodape.component';

@Component({
  selector: 'app-produtos',
  standalone: true,
  imports: [CommonModule, MenuComponent, RodapeComponent],
  templateUrl: './produtos.component.html',
  styleUrl: './produtos.component.css'
})
export class ProdutosComponent implements OnInit {
  selectedProduct: string = 'playout';

  constructor(private title: Title, private meta: Meta) {}

  ngOnInit() {
    this.title.setTitle('Produtos - Fluxodigital - Web | Infra');
    this.meta.updateTag({ 
      name: 'description', 
      content: 'Descubra as soluções inovadoras da Fluxodigital. FluxoPlayOut para automação de TV profissional e AngloAn VPN para navegação segura e rápida.' 
    });
    
    // Open Graph
    this.meta.updateTag({ property: 'og:title', content: 'Produtos - Fluxodigital - Web | Infra' });
    this.meta.updateTag({ property: 'og:description', content: 'Soluções críticas para sectores empresariais: FluxoPlayOut e AngloAn VPN.' });
  }

  setProduct(product: string) {
    this.selectedProduct = product;
  }
}
